import React from "react";

interface SocialIconProps {
  size?: number;          // icon width & height in pixels
  color?: string;         // icon fill color (Tailwind color or hex)
  className?: string;     // extra classes for styling
  url: string;            // link to social profile
  label: string;          // accessible label, e.g. "Facebook"
}

export const FacebookIcon: React.FC<SocialIconProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  url,
  label,
}) => (
  <a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    className={className}
  >
    <svg
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
      role="img"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{label}</title>
      <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
    </svg>
  </a>
);

export const InstagramIcon: React.FC<SocialIconProps> = ({
  size = 24,
  color = "currentColor",
  className = "",
  url,
  label,
}) => (
  <a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    className={className}
  >
    <svg
      width={size}
      height={size}
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="0 0 24 24"
      role="img"
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{label}</title>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37a4 4 0 1 1-4.73-4.73 4 4 0 0 1 4.73 4.73z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  </a>
);
